import { MapPin } from "lucide-react";
import Reveal from "./Reveal";

const AREAS = [
  "St. John's",
  "Mount Pearl",
  "Paradise",
  "Conception Bay South",
  "Torbay",
  "Portugal Cove–St. Philip's",
  "Logy Bay–Middle Cove–Outer Cove",
  "Bay Bulls / Witless Bay",
  "Pouch Cove",
  "…and the whole Avalon",
];

export default function ServiceArea() {
  return (
    <section id="areas" data-testid="service-area-section" className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-36">
      <div className="grid gap-14 lg:grid-cols-[1fr_1.4fr] lg:gap-24">
        <Reveal>
          <p className="eyebrow">Where we clean</p>
          <h2 className="mt-4 font-serif text-4xl tracking-tight text-ink sm:text-5xl">
            Proudly serving the <span className="italic text-ocean">Avalon</span>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-slateblue">
            Based in the St. John's area, we're happy to travel to homes and businesses
            across the peninsula. Don't see your community listed? Just ask.
          </p>
        </Reveal>

        <Reveal i={1} data-testid="area-list-card" className="rounded-2xl border border-ink/10 bg-white p-8 lg:p-10">
          <h3 className="font-serif text-xl tracking-tight text-ink">Areas we serve</h3>
          <ul className="mt-6 grid gap-x-8 gap-y-3 sm:grid-cols-2">
            {AREAS.map((a) => (
              <li key={a} className="flex items-center gap-3 text-base font-medium text-ink">
                <MapPin className="h-4 w-4 shrink-0 text-seafoam" />
                {a}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
